// extracted by mini-css-extract-plugin
export var cancelButton = "_py-5";
export var content = "_py-3";
export var createButton = "_py-6";
export var drawerContainer = "_py-0";
export var footer = "_py-2";
export var header = "_py-1";
export var orderFormColumn = "_py-4";